<template>
  <Delete
    resource="cost-items"
    dispatch="projectAccountingStore/costItemStore/delete"
    routing="cost-items"
    :id="id"
    :params="{ project_id: $route.params.project_id }"
    :disabled="disabled"
  ></Delete>
</template>

<script>
import Delete from "../../../common/tabs/Delete";
import { projectPermissions } from "../../../mixins/projects/projectPermissions";

export default {
  name: "DeleteCostItem",
  props: ["id"],
  mixins: [projectPermissions],
  components: { Delete },
  computed: {
    disabled: {
      get() {
        return !this.hasCurrentProjectPermissions("cost_item.delete");
      }
    }
  }
};
</script>

<style scoped></style>
